export function RenderArrayDetail(arr) {
  return arr?.join(" , ");
}


